import service from './baseService';
import { getModelTypeIDAndEntityID } from '../config';

export const getPayrollPeriodsService = () => {
    return service.get('/payroll-periods', { params: getModelTypeIDAndEntityID() });
};
